// extracted by mini-css-extract-plugin
export var link = "_ud-0";